<b class="ellipse-text">{{ dimensionName.name }}</b>
<div class="ellipse-inline-icons icons">
    <a class="icon" *ngIf="showRemoveBtn" (click)="onRemoveClicked()">
        <span class="material-icons-outlined">close</span>
    </a>
    <a class="icon" *ngIf="showCreateSingleDimCardBtn" (click)="onCreateSingleDimCardClicked()">
        <span class="material-icons-outlined rotate270">vertical_align_bottom</span>
    </a>
</div>